import { render, staticRenderFns } from "./StickyHeaderVehicleClassPerformance.vue?vue&type=template&id=484a79bb&"
import script from "./StickyHeaderVehicleClassPerformance.vue?vue&type=script&lang=js&"
export * from "./StickyHeaderVehicleClassPerformance.vue?vue&type=script&lang=js&"
import style0 from "./StickyHeaderVehicleClassPerformance.vue?vue&type=style&index=0&id=484a79bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports